import React from 'react';
import FooterTop from './FooterTop';
import FooterBottom from './FooterBottom';

interface Props {}

const DefaultFooter: React.FC<Props> = () => {
  return (
    <div className="foot-new-pc mobilenoshow">
      <FooterTop />
      <FooterBottom />
    </div>
  );
};

export default DefaultFooter;
